import Barcode from 'react-barcode';
import xpengImg from './xpeng.png';
import './index.less';

const PrintA4 = (props: { barcode?: string; title: string; children: React.ReactNode }) => {
  return (
    <div id='ASS_PART_ROOT' className='_print_page_-a4'>
      <div className={'_print_page_wrapper'}>
        <table className='_print_page_layout-table'>
          <thead>
            <tr>
              <td>
                <div className='_print_page_header-space'>
                  <div className='barcode'>
                    {props.barcode && <Barcode renderer='img' value={props.barcode} />}
                  </div>
                  <img className='logo' src='https://s.xiaopeng.com/xp-dragon/71/logo.png' />
                  <div className={'title'}>{props.title}</div>
                </div>
              </td>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>
                <div className='_print_page_main-content'>{props.children}</div>
              </td>
            </tr>
          </tbody>

          <tfoot>
            <tr>
              <td>
                <div className='_print_page_footer-space' />
              </td>
            </tr>
          </tfoot>
        </table>

        <div className='_print_page_footer'>
          <img className='_print_page_footer-brand' src={xpengImg} alt='xpeng' />
        </div>
      </div>
    </div>
  );
};
PrintA4.pageStyle = `
@page {
  margin: 0;
  size: A4 !important;
}
@media print {
  html, body {
    height: initial !important;
    overflow: initial !important;
  },
}
`;
export default PrintA4;
